import { Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarRef } from '@angular/material/snack-bar';
import { MatDialog } from '@angular/material/dialog';
import { Observable } from 'rxjs';

import { ActionNotificationComponent } from '../components/action-notification/action-notification.component';
import { ConfirmationDialogComponent } from '../components/confirmation-dialog/confirmation-dialog.component';

@Injectable()
export class LayoutUtility {
  constructor(private snackBar: MatSnackBar, private dialog: MatDialog) {}

  showActionNotification(
    type: 'INFO' | 'ERROR' | 'SUCCESS',
    message: string,
    duration = 3000,
    showCloseBtn = true,
    verticalPosition: 'top' | 'bottom' = 'bottom',
  ): MatSnackBarRef<any> {
    return this.snackBar.openFromComponent(ActionNotificationComponent, {
      duration,
      verticalPosition,
      data: { snackBar: this.snackBar, type, message, showCloseBtn },
      panelClass: [
        'ks-action-notification-snackbar',
        type === 'INFO'
          ? 'ks-info-action'
          : type === 'SUCCESS'
          ? 'ks-success-action'
          : 'ks-error-action',
      ],
    });
  }

  openConfirmationDialog(data: {
    themeColor: 'primary' | 'secondary' | 'tertiary' | 'danger' | 'warning' | 'success' | 'neutral';
    iconPath: string;
    content: string;
    cancelLabel: string;
    confirmLabel: string;
  }): Observable<boolean> {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: '450px',
      height: '300px',
      disableClose: true,
      closeOnNavigation: true,
      data,
    });

    return dialogRef.afterClosed();
  }
}
